import React from "react";
import { Link } from "react-router-dom";
import "./homepage.css";

function HomePage() {
  return (
    <div className="homepage-container">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Effortless Blockchain Automation</h1>
          <p>Made for everyone. No-code blockchain automation that triggers real-world actions based on smart contract events.</p>
          <div className="hero-buttons">
            <Link to="/login" className="btn primary-btn">Login</Link>
            <Link to="/register" className="btn secondary-btn">Register</Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features">
        <h2>Why Easy Connect?</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>No-code Blockchain Automation</h3>
            <p>Trigger workflows with Make or Zapier based on smart contract events.</p>
          </div>
          <div className="feature-card">
            <h3>Smart Contract Monitoring</h3>
            <p>Monitor any contract method and set advanced filters.</p>
          </div>
          <div className="feature-card">
            <h3>Flexible Notifications</h3>
            <p>Email, webhooks, Discord, Telegram, Google Sheets & more.</p>
          </div>
          <div className="feature-card">
            <h3>Scalable Alerts</h3>
            <p>Freemium + premium plans for power users and teams.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Ready to automate your blockchain workflows?</h2>
        <Link to="/register" className="btn primary-btn">Try it now!</Link>
      </section>
    </div>
  );
}

export default HomePage;
